import { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

// Shows an "Install app" button when the browser supports PWA install (Chrome/Edge).
export default function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferred(e);
    };
    window.addEventListener("beforeinstallprompt", handler);
    window.addEventListener("appinstalled", () => setDeferred(null));
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    await deferred.userChoice;
    setDeferred(null);
  };

  const isStandalone =
    window.matchMedia?.("(display-mode: standalone)").matches ||
    window.navigator.standalone;

  if (!deferred || dismissed || isStandalone) return null;

  return (
    <div
      data-testid="install-app-banner"
      className="fixed bottom-4 right-4 z-[60] flex items-center gap-3 bg-white border border-[#E2DFD8] rounded-2xl shadow-[0_12px_32px_rgba(18,24,20,0.16)] px-4 py-3 max-w-[320px] fade-up"
    >
      <div className="w-9 h-9 rounded-xl bg-[#4A6B53] flex items-center justify-center shrink-0">
        <Download className="w-4 h-4 text-white" strokeWidth={1.5} />
      </div>
      <div className="min-w-0">
        <p className="text-sm font-semibold text-[#121814] leading-tight">Install PSR Notes</p>
        <p className="text-xs text-[#7A8C82] leading-tight">Add it to your desktop like an app.</p>
      </div>
      <button
        data-testid="install-app-btn"
        onClick={install}
        className="ml-1 h-9 px-3 rounded-full bg-[#4A6B53] hover:bg-[#3D5A45] text-white text-sm font-medium transition-colors shrink-0"
      >
        Install
      </button>
      <button
        data-testid="install-dismiss-btn"
        onClick={() => setDismissed(true)}
        className="text-[#7A8C82] hover:text-[#C26D5C] shrink-0"
      >
        <X className="w-4 h-4" strokeWidth={1.5} />
      </button>
    </div>
  );
}
